import {
  CARTPRODUCTADD,
  CARTPRODUCTREMOVE,
  CARTQTYDECREMENT,
  CARTQTYINCREMENT
} from "../cart/actionTypes";
import { PRODUCTQTYMINUS, PRODUCTQTYPLUS } from "../product/actionTypes";

const productQtyCheck = (store) => (next) => (action) => {
  if (action?.type === CARTPRODUCTADD) {
    // Negative quantity check
    store?.getState()?.product?.map((product) => {
      if (product.id === action.product.id)
        if (product.quantity - action.product.quantity >= 0)
          return next(action);
    });
  } else if (action.type === CARTQTYINCREMENT) {
    // Negative quantity check
    store?.getState()?.product?.map((product) => {
      if (product.id === action.id)
        if (product.quantity - action.value >= 0) return next(action);
    });
  } else if (action.type === CARTQTYDECREMENT) {
    // Negative quantity check
    store?.getState()?.cart?.map((product) => {
      if (product.id === action.id)
        if (product.quantity - action.value > 0) return next(action);
    });
  } else if (action.type === PRODUCTQTYMINUS) {
    // Negative quantity check
    store?.getState()?.product?.map((product) => {
      if (product.id === action.id)
        if (product.quantity - action.value >= 0) return next(action);
    });
  } else if (action.type === PRODUCTQTYPLUS) {
    store?.getState()?.cart?.map((product) => {
      if (product.id === action.id)
        if (product.quantity > 0) return next(action);
    });
  } else if (action?.type === CARTPRODUCTREMOVE) {
    return next(action);
  }
};

export default productQtyCheck;
